"use client";

// components/public/SoftRecoveryHopLink.tsx
// Sponsored-hop card for SoftRecovery items that opt in with `hop`. Same link
// contract as the guide pricing cards (MidArticleCta "hop" branch):
// GoPrefetchAnchor (post-hydration ?src=<path>), target=_blank,
// rel="sponsored nofollow noopener noreferrer", hrefLang, an aria-label that
// mirrors the visible title, and the cta_click beacon before navigation.

import type { ReactNode } from "react";
import GoPrefetchAnchor from "@/components/public/GoPrefetchAnchor";
import { trackCtaClick } from "@/lib/tracking/client-track";

export function SoftRecoveryHopLink({
  href,
  title,
  placement,
  className,
  children,
}: {
  href: string;
  title: string;
  placement: string;
  className: string;
  children: ReactNode;
}) {
  return (
    <GoPrefetchAnchor
      href={href}
      target="_blank"
      rel="sponsored nofollow noopener noreferrer"
      hrefLang="en"
      aria-label={`${title} (opens in new tab)`}
      onClick={() => trackCtaClick({ linkUrl: href, ctaPlacement: placement })}
      className={className}
    >
      {children}
    </GoPrefetchAnchor>
  );
}
